/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { Component } from "react";
import BusApiCall from "../helper/axios.js";
import Loader from "../component/loader/index.js";
import { connect } from "react-redux";
import HeaderNoAuth from "../component/header/headerNoAuth.js";
import actionTypes from "../store/actions.js";
import constants from "../helper/constants.js";
import { Grid } from "@mui/material";
import Input from "../component/inputpm/index.js";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { withTranslation } from "react-i18next";
import {
  FormControl,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  IconButton,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import Button from "../component/button/index.js";
import { withNavigation } from "../helper/withNavigation.js";

class SignUp extends Component {
  // Declare property values that belongs to the component
  state = {
    loading: false,
    id: "",
    email: "",
    firstname: "",
    lastname: "",
    customerBan: "",
    password: "",
    repeatPassword: "",
    showMessageCard: false,
  };

  // Intial HTTP calls or data manipulation on page load
  componentDidMount() {
    // Remove error message on component load
    this.props.setCompDidMount();
  }

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  validateEmail = (mail) => {
    return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail);
  };

  cancel = () => {
    window.localStorage.setItem("doLogin", false);
    // this.props.router.navigate(localStorage.getItem('redirectUrl'));
    this.props.router.navigate("/solutions");
  };

  createAccount = () => {
    if (
      this.state.id.trim().length == 0 ||
      this.state.email.trim().length == 0 ||
      this.state.firstname.trim().length == 0 ||
      this.state.lastname.trim().length == 0 ||
      this.state.customerBan.trim().length == 0 ||
      this.state.password.trim().length == 0 ||
      this.state.repeatPassword.trim().length == 0
    ) {
      this.props.setErrorMessage("Please fill all fields marked by *", false);
    } else if (!this.validateEmail(this.state.email)) {
      this.props.setErrorMessage(
        "Invalid Email. Enter a valid email address",
        false,
      );
      // } else if (!this.validateEmail(this.state.id + "@" + this.props.tenantId + ".com")) {
    } else if (!this.validateEmail(this.state.id + "@spottel.com")) {
      this.props.setErrorMessage(
        "Invalid username. Enter a valid username",
        false,
      );
    } else if (this.state.password != this.state.repeatPassword) {
      this.props.setErrorMessage(
        "The password field values do not match.",
        false,
      );
    } else {
      this.setState({ loading: true });
      let data = {
        id: this.state.id,
        email: this.state.email,
        firstname: this.state.firstname,
        lastname: this.state.lastname,
        customerBan: this.state.customerBan,
        password: this.state.password,
        tenantId: "spottel",
      };
      BusApiCall("POST", `${constants.openUserUrl}/user`, data)
        .then((res) => {
          // this.props.setErrorMessage("User created successfully with id: " + this.state.id + ".", true);
          this.setState({
            id: "",
            email: "",
            firstname: "",
            lastname: "",
            customerBan: "",
            password: "",
            repeatPassword: "",
            showMessageCard: true,
            loading: false,
          });
          // this.props.router.navigate('/solutions');
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.message) {
            this.props.setErrorMessage(err.response.data.message, false);
          } else {
            console.log(err);
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
          this.setState({ loading: false, showMessageCard: false });
        });
    }
  };

  sendToLogin = () => {
    window.localStorage.setItem("doLogin", true);
    window.location.reload();
  };

  render() {
    const t = this.props.t;
    return (
      <React.Fragment>
        {/* <HeaderNoAuth /> */}
        <main>
          <Grid container justifyContent="center">
            <Grid
              item
              size={{
                md: 6,
              }}
            >
              <Card>
                {this.state.showMessageCard ? (
                  <CardContent>
                    <Grid container spacing={3}>
                      <Grid
                        item
                        align="center"
                        size={{
                          xs: 12,
                        }}
                      >
                        <h3 className={"no-margin"}>
                          Your User ID has been created and the credentials have
                          been emailed to your registered email address. &nbsp;
                          <span
                            className="continueToLoginLink"
                            onClick={() => this.sendToLogin()}
                          >
                            Continue to Login
                          </span>
                        </h3>
                      </Grid>
                    </Grid>
                  </CardContent>
                ) : (
                  <CardContent>
                    <Grid container spacing={3}>
                      <Grid
                        item
                        align="center"
                        size={{
                          xs: 12,
                        }}
                      >
                        <h3 className={"no-margin"}>{t("CREATE_USER")}</h3>
                      </Grid>
                      <Grid
                        item
                        size={{
                          xs: 6,
                        }}
                      >
                        <Input
                          size={"small"}
                          variant={"outlined"}
                          name="firstname"
                          placeholder={t("FIRST_NAME") + " *"}
                          onChange={(event) => this.onChange(event)}
                          value={this.state.firstname}
                        />
                      </Grid>
                      <Grid
                        item
                        size={{
                          xs: 6,
                        }}
                      >
                        <Input
                          size={"small"}
                          variant={"outlined"}
                          name="lastname"
                          placeholder={t("LAST_NAME") + " *"}
                          onChange={(event) => this.onChange(event)}
                          value={this.state.lastname}
                        />
                      </Grid>
                      <Grid
                        item
                        size={{
                          xs: 6,
                        }}
                      >
                        <Input
                          size={"small"}
                          variant={"outlined"}
                          name="email"
                          placeholder={t("EMAIL") + " *"}
                          onChange={(event) => this.onChange(event)}
                          value={this.state.email}
                        />
                      </Grid>
                      <Grid
                        item
                        size={{
                          xs: 6,
                        }}
                      >
                        <Input
                          size={"small"}
                          variant={"outlined"}
                          name="customerBan"
                          placeholder={t("CUSTOMER_BAN") + " *"}
                          onChange={(event) => this.onChange(event)}
                          value={this.state.customerBan}
                        />
                      </Grid>
                      <Grid
                        item
                        size={{
                          xs: 6,
                        }}
                      >
                        <Input
                          size={"small"}
                          variant={"outlined"}
                          name="id"
                          placeholder={t("USERNAME") + " *"}
                          onChange={(event) => this.onChange(event)}
                          value={this.state.id}
                        />
                      </Grid>
                      {/* <Grid item xs={6}>
                                            <span align="left">@{this.props.tenantId}.com</span>
                                        </Grid> */}
                      <Grid
                        item
                        size={{
                          xs: 6,
                        }}
                      >
                        <FormControl
                          variant="outlined"
                          size={"small"}
                        >
                          <InputLabel id="outlined-adornment-password">
                            {t("PASSWORD") + " *"}
                          </InputLabel>
                          <OutlinedInput
                            labelId="outlined-adornment-password"
                            type="password"
                            name="password"
                            label={t("PASSWORD") + " *"}
                            value={this.state.password}
                            onChange={(event) => this.onChange(event)}
                          />
                        </FormControl>
                      </Grid>
                      <Grid
                        item
                        size={{
                          xs: 6,
                        }}
                      >
                        <Input
                          size={"small"}
                          variant={"outlined"}
                          name="repeatPassword"
                          type="password"
                          placeholder={t("REPEAT_PASSWORD") + " *"}
                          onChange={(event) => this.onChange(event)}
                          value={this.state.repeatPassword}
                        />
                      </Grid>
                      <Grid
                        item
                        align="right"
                        size={{
                          xs: 12,
                        }}
                      >
                        <Button onClick={() => this.cancel()}>
                          {t("CANCEL")}
                        </Button>
                        <Button
                          onClick={() => this.createAccount()}
                          style={{ marginLeft: "15px" }}
                        >
                          {t("CREATE_USER")}
                        </Button>
                      </Grid>
                    </Grid>
                  </CardContent>
                )}
              </Card>
            </Grid>
          </Grid>
        </main>
        <Loader loading={this.state.loading} />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    tenantId: state.auth.tenantId,
    publicBrowsing: state.auth.publicBrowsing,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
    setCompDidMount: () =>
      dispatch({ type: actionTypes.GLOBAL_COMP_DID_MOUNT }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(withNavigation(SignUp)));
